import {useTranslation} from 'react-i18next'

export const RowHead = () => {
  const {t} = useTranslation()

  return (
    <tr>
      <th>{t('No')}</th>
      <th>{t('No Transaction')}</th>
      <th>{t('Customer')}</th>
      <th>{t('Status')}</th>
      <th>{t('Message Error')}</th>
      <th>{t('Date')}</th>
      <th>{t('No SO')}</th>
      <th>{t('No DP Req')}</th>
      <th>{t('No Billing DP')}</th>
      <th>{t('TableBank.bank_clearing_acct')}</th>
      <th>{t('Clearing Doc 1')}</th>
      <th>{t('Clearing Doc 2')}</th>
      <th>{t('mataUang')}</th>
      <th>{t('Bank Payment')}</th>
      <th>{t('Aksi')}</th>
    </tr>
  )
}
